import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProgramShipmentsPage } from './program-shipments';
import { MatExpansionModule, MatFormFieldModule, MatSelectModule, MatButtonModule, MatOptionModule, MatAutocompleteModule, MatDatepickerModule, MatIconModule, MatTableModule, MatPaginatorModule, MatSortModule, MatInputModule } from '@angular/material';

@NgModule({
  declarations: [
    ProgramShipmentsPage,
  ],
  imports: [
    IonicPageModule.forChild(ProgramShipmentsPage),
    MatExpansionModule, MatFormFieldModule, MatSelectModule, MatButtonModule, MatOptionModule, MatAutocompleteModule, MatDatepickerModule, MatIconModule, MatTableModule, MatPaginatorModule, MatSortModule, MatInputModule
  ],
})
export class ProgramShipmentsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/program-shipments/program-shipments.module.ts